export default "__VITE_ASSET__B5Rwcs7J__"